import React from "react";
import type { ReactNode } from "react";

interface Props {
  direction?: "row" | "column",
  gap?: 1 | 2 | 4 | 8 | 10 | 12 | 16 | 20 | 24 | 32 | 40 | 48 | 64 | 80 | 96 | 112 | 128,
  justifyContent?: "flex-start" | "center" | "flex-end" | "space-between" | "space-around" | "space-evenly",
  alignItems?: "flex-start" | "center" | "flex-end" | "stretch" | "baseline",
  children: ReactNode
}

export function Stack({ direction, gap, justifyContent, alignItems, children }: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: direction,
        gap,
        justifyContent,
        alignItems
      }}
    >
      {children}
    </div>
  )
}

